import { Text } from '@public/components/UI/Typography/Text';

import styles from './DraftByStarsLegend.module.scss';

export const DraftByStarsLegend = () => {
  return (
    <ul className={styles.legendContainer}>
      <li className={styles.legendItem}>
        <Text variant="h5">Draft Blue Chip Share</Text>
        <Text
          className={styles.description}
          component="span"
          variant="subtitle2"
        >
          <span>The percentage of drafted blue chips owned by states.</span>
          <span>(State&#39;s Draft Bluechips / Total Drafted Blue Chips)</span>
        </Text>
      </li>
      <li>
        <Text variant="h5">Population</Text>
        <Text
          className={styles.description}
          component="span"
          variant="subtitle2"
        >
          <span>
            The percent of the population the state owns out of the entire
            United States.
          </span>

          <span>(State&#39;s Population / Total US Population)</span>
        </Text>
      </li>
      <li>
        <Text variant="h5">
          Draft Talent Ratio <span aria-label="Percentage">%</span>
        </Text>
        <Text
          className={styles.description}
          component="span"
          variant="subtitle2"
        >
          <span>
            The ratio of draft blue chip players to the population share.
          </span>
          <span>(Draft Blue Chip Share / Population)</span>
        </Text>
      </li>
    </ul>
  );
};
